module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "v-tabs notes-list"
  }, [_c('div', {
    staticClass: "head"
  }, [_c('div', {
    staticClass: "total"
  }, [_vm._v("\n        累计" + _vm._s(_vm.page.total) + "次开票  开票总金额 "), _c('span', {
    staticClass: "red"
  }, [_vm._v(_vm._s(_vm.allTotalMoney))]), _vm._v(" 元\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "inline-item"
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "size": "small",
      "value-format": "yyyy-MM-dd",
      "type": "daterange",
      "unlink-panels": "",
      "start-placeholder": "开始时间",
      "end-placeholder": "结束时间"
    },
    on: {
      "change": _vm.datepicker
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "inline-item"
  }, [(_vm.moduleName !== 'paymentApi' && _vm.InvoiceAdd) ? _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.addNew
    }
  }, [_vm._v("新建发票")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    ref: "content",
    staticClass: "content"
  }, [_c('ul', {
    staticClass: "item-list"
  }, [(!_vm.tableData.length) ? _c('li', {
    staticClass: "item center"
  }, [_vm._v("暂无数据")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.tableData), function(item) {
    return _c('li', {
      staticClass: "item"
    }, [_c('span', {
      staticClass: "date"
    }, [_vm._v(_vm._s(item.invoiceDate))]), _vm._v(" "), _c('div', {
      staticClass: "order"
    }, [_c('div', {
      staticClass: "head-top"
    }, [_c('div', {
      staticClass: "id"
    }, [_c('i', {
      staticClass: "ico purple"
    }, [_vm._v("票")]), _vm._v(" "), _c('a', {
      staticClass: "link",
      class: {
        red: item.isRed
      },
      on: {
        "click": function($event) {
          _vm.openDetail(item.id)
        }
      }
    }, [_vm._v(_vm._s(item.sheetNo))])]), _vm._v(" "), (item.isMerge) ? _c('span', [_vm._v("合并开票")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "good"
    }, [_vm._m(0, true), _vm._v(" "), _c('span', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.totalMoney) + _vm._s(item.unit))])]), _vm._v(" "), _c('div', {
      staticClass: "response"
    }, [_vm._v("申请人：" + _vm._s(item.userName))])])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "load-more"
  }, [(_vm.showLoadmore) ? [_c('i', {
    staticClass: "el-icon-loading"
  }), _vm._v("\n        加载更多\n      ")] : _vm._e(), _vm._v(" "), (!_vm.showLoadmore && _vm.page.total > _vm.page.size) ? [_vm._v("没有更多")] : _vm._e()], 2), _vm._v(" "), (_vm.addnewShow) ? _c('add-new', {
    ref: "addNew",
    attrs: {
      "modal": false,
      "addnewProp": _vm.addnewProp
    },
    on: {
      "refresh": _vm.refresh,
      "closeForDetail": function($event) {
        _vm.addnewShow = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "thumb"
  }, [_c('i', {
    staticClass: "web-icon-dollar-circle"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c9057ef","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/detail/invoice-history.vue
// module id = 1283
// module chunks = 82